export default "__VITE_ASSET__CnKPjejg__"